/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Round_TimeInputs */



/**
* | output |
* | --- |
* | "Round time" |
*
* @param {Og_Cfg_Round_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_round_time = /** @type {((inputs?: Og_Cfg_Round_TimeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Round_TimeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée de ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo de ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Tempo da rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo del round")
	return /** @type {LocalizedString} */ ("Round time")
});